export type Step = 'industry' | 'application' | 'application_specific' | 'project' | 'preview';

export const Steps: Record<Step, Step> = {
    industry: 'industry',
    application: 'application',
    application_specific: 'application_specific',
    project: 'project',
    preview: 'preview'
};
